import { render, staticRenderFns } from "./TruckPerformanceReportComponent.vue?vue&type=template&id=218b0432&scoped=true"
import script from "./TruckPerformanceReportComponent.vue?vue&type=script&lang=js"
export * from "./TruckPerformanceReportComponent.vue?vue&type=script&lang=js"
import style0 from "./TruckPerformanceReportComponent.vue?vue&type=style&index=0&id=218b0432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b0432",
  null
  
)

export default component.exports